(function () {
    'use strict';

    angular.module("imApp").factory("subtasksService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 926,
                    parameters: parms || {}
                });
            },
            listSubTasks: function (parms) {
                return $ihttp.post({
                    method: 115,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
